import { formatMoney } from '@metapic-apps/shared'

/** Admin policy: show a prefixed ISO currency code while the shared formatter owns the number. */
export const formatMoneyForAdmin: typeof formatMoney = (money, options) =>
  formatMoney(money, {
    ...options,
    locale: 'en-GB',
    currencyDisplay: 'code',
    currencyLocale: 'en-GB',
  })
